import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Calendar = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="calendar icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path className={pathClass} d="M10.5 15H13.5V18H10.5V15Z" />
    <path className={pathClass} d="M13.5 10H10.5V13H13.5V10Z" />
    <path className={pathClass} d="M15 10H18V13H15V10Z" />
    <path className={pathClass} d="M9 10H6V13H9V10Z" />
    <path className={pathClass} d="M6 15H9V18H6V15Z" />
    <path className={pathClass} d="M18 15H15V18H18V15Z" />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2ZM21 7H3V21H21V7Z"
    />
  </svg>
)
